const SELECTOR = '[data-ts-vf]';

const DATA = {"10977":{rated:16,ratedLabel:"16LB",peak:28.1,time:5.79,inst:"Mark-10 ESM303",date:"1 May 2026",samples:201,curve:[0,2,5,8,11,14,17,20,22,24,26,27.4,28.1]},"22841":{rated:30,ratedLabel:"30LB",peak:49.6,time:6.42,inst:"Mark-10 ESM303",date:"14 May 2026",samples:214,curve:[0,3,7,12,17,22,27,32,37,41,45,48,49.6]},"30112":{rated:80,ratedLabel:"80LB",peak:108.3,time:7.1,inst:"Mark-10 ESM303",date:"22 May 2026",samples:189,curve:[0,8,18,30,42,54,66,77,87,95,102,106,108.3]}};

const BLUE = "#394f9b";

function init(root){
var inp=root.querySelector(".vf-inp"),btn=root.querySelector(".vf-btn"),cert=root.querySelector(".vf-cert"),err=root.querySelector(".vf-err"),pill=root.querySelector(".vf-pill"),svg=root.querySelector(".vf-svg");
if(!inp||!btn||!cert||!err||!pill||!svg){return}
function q(sel){return cert.querySelector(sel)}
function clean(v){return String(v||"").replace(/[^0-9]/g,"").slice(0,12)}
function chart(d){
var W=620,H=300,pl=64,pr=24,pt=20,pb=34;
var maxL=d.peak*1.12;
function y(v){return H-pb-(v/maxL)*(H-pt-pb)}
function x(i,n){return pl+(i/(n-1))*(W-pl-pr-40)}
var n=d.curve.length,pts=[],i;
for(i=0;i<n;i++){pts.push(x(i,n).toFixed(1)+","+y(d.curve[i]).toFixed(1))}
var peakX=x(n-1,n),peakY=y(d.peak);
pts.push(peakX.toFixed(1)+","+(H-pb).toFixed(1));
var s='';
s+='<line x1="'+pl+'" y1="'+pt+'" x2="'+pl+'" y2="'+(H-pb)+'" stroke="#ddd" stroke-width="1"/>';
s+='<line x1="'+pl+'" y1="'+(H-pb)+'" x2="'+(W-pr)+'" y2="'+(H-pb)+'" stroke="#111" stroke-width="1.5"/>';
s+='<line x1="'+pl+'" y1="'+peakY.toFixed(1)+'" x2="'+(W-pr)+'" y2="'+peakY.toFixed(1)+'" stroke="'+BLUE+'" stroke-width="1.5"/>';
s+='<line x1="'+pl+'" y1="'+y(d.rated).toFixed(1)+'" x2="'+(W-pr)+'" y2="'+y(d.rated).toFixed(1)+'" stroke="'+BLUE+'" stroke-width="1.5"/>';
s+='<text x="'+(pl-8)+'" y="'+(peakY+4).toFixed(1)+'" text-anchor="end" font-size="13" font-weight="700" fill="#111">'+d.peak+'LB</text>';
s+='<text x="'+(pl-8)+'" y="'+(y(d.rated)+4).toFixed(1)+'" text-anchor="end" font-size="13" font-weight="700" fill="#111">'+d.ratedLabel+'</text>';
s+='<text x="'+(pl-8)+'" y="'+(H-pb+4)+'" text-anchor="end" font-size="13" font-weight="700" fill="#111">0 LB</text>';
s+='<polyline class="vf-line" fill="none" stroke="#111" stroke-width="2.5" points="'+pts.join(" ")+'"/>';
s+='<circle cx="'+peakX.toFixed(1)+'" cy="'+peakY.toFixed(1)+'" r="6" fill="#111"/>';
svg.innerHTML=s;
var line=svg.querySelector(".vf-line");
try{var L=line.getTotalLength();line.style.strokeDasharray=L;line.style.strokeDashoffset=L;line.getBoundingClientRect();line.style.transition="stroke-dashoffset 2.2s ease-out";line.style.strokeDashoffset="0"}catch(e){}
}
function show(nRaw){
var n=clean(nRaw);var d=DATA[n];
if(!d){cert.hidden=true;pill.hidden=true;err.hidden=false;return}
err.hidden=true;pill.hidden=false;cert.hidden=false;
q('[data-vf=num]').textContent=n;q('[data-vf=num2]').textContent=n;
q('[data-vf=rated]').textContent=d.ratedLabel;q('[data-vf=rated2]').textContent=d.rated+" lb";
q('[data-vf=peak]').textContent=d.peak+"LB";q('[data-vf=peak2]').textContent=d.peak+" lbF";
q('[data-vf=date]').textContent=d.date;q('[data-vf=samples]').textContent=d.samples;q('[data-vf=con]').textContent=d.inst;
chart(d);
try{history.replaceState(null,"",location.pathname+"?spool="+n)}catch(e){}
cert.scrollIntoView({behavior:"smooth",block:"nearest"});
}
btn.addEventListener("click",function(){show(inp.value)});
inp.addEventListener("keydown",function(e){if(e.key==="Enter")show(inp.value)});
var p=new URLSearchParams(location.search);var pre=clean(p.get("spool")||p.get("id"));
if(pre){inp.value="#"+pre;show(pre)}
}

function initAll(scope){
  (scope||document).querySelectorAll(SELECTOR).forEach(r=>{ if(r.dataset.vfReady) return; r.dataset.vfReady='1'; init(r); });
}

initAll();
document.addEventListener('shopify:section:load', e => initAll(e.target));
